
import TerminalMusicEditor from './TerminalMusicEditor';
import GaryBuseyLookALikes from './GaryBuseyLookALikes';
import GetLucky3000 from './GetLucky3000'


const ModalContent = (props) => {

    if (props.project === 'getLucky') {
        return (
            <GetLucky3000 />
        )
    } else if (props.project === 'garybuseylookalikes') {
        return (
            <GaryBuseyLookALikes />
        )

    } else if (props.project === 'musicterminalapp') {
        return (
            <TerminalMusicEditor />
        )
    } else {
        return null
    }

    

}


export default ModalContent